import { Controller } from "@hotwired/stimulus"
import isTesting from "../utils/isTesting"

export default class extends Controller {
    connect() {
        const testing = isTesting()

        this.modalInstance = M.Modal.init(this.element, {
            inDuration: testing === null ? 350 : 0,
            outDuration: testing === null ? 250 : 0,
            onCloseEnd: () => this.element.remove()  // remove after fadeout
        })

        this.modalInstance.open()

        // Listen for custom event
        this.element.addEventListener("modal:close", () => this.close())
    }

    close() {
        this.modalInstance.close()
    }
}
